var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [_vm._t("endForm")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }